export default __webpack_public_path__ + "static/media/play.ab78ee2d.svg";